import React from "react";
import { Container, Row } from "react-bootstrap";
import WorkCard from "../components/WorkCard";
import articleData from "../data.json";

const posts = articleData.data;

const Works = () => {
  return (
    <Container className="mt-5 mb-5">
      <h1 className="mb-3">Works</h1>
      <Row lg={4} md={6} className="g-4">
        {posts.map((post) => (
          <WorkCard post={post} />
        ))}
      </Row>
    </Container>
  );
};

export default Works;
